import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

export function mapSubscriptionFromApi(d) {
  return {
    companyId: Number(d.companyId || 0),
    companyName: d.companyName ?? '',
    companyEmail: d.companyEmail ?? '',
    companyPhone: d.companyPhone ?? '',
    packageName: d.packageName ?? '',
    packageLabel: d.packageLabel ?? '',
    ceoUserName: d.ceoUserName ?? '',
    ceoFullName: d.ceoFullName ?? '',
    ceoEmail: d.ceoEmail ?? '',
    ceoPhone: d.ceoPhone ?? '',
    isTrialSubscription: Boolean(d.isTrialSubscription),
    trialEndsAtUtc: d.trialEndsAtUtc ?? '',
    isCompanyActive: Boolean(d.isCompanyActive),
  };
}

export async function fetchSuperAdminSubscriptions() {
  const res = await fetch(`${API_BASE}/api/superadmin/subscriptions`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ([]));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل الاشتراكات'));
  return (Array.isArray(data) ? data : []).map(mapSubscriptionFromApi);
}
